import { render, staticRenderFns } from "./CascadeMatterChecker.vue?vue&type=template&id=8d56f980&scoped=true&"
import script from "./CascadeMatterChecker.vue?vue&type=script&lang=js&"
export * from "./CascadeMatterChecker.vue?vue&type=script&lang=js&"
import style0 from "./CascadeMatterChecker.vue?vue&type=style&index=0&id=8d56f980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d56f980",
  null
  
)

export default component.exports